<template>
  <span>{{result}}</span>
</template>
<script>
import store from './dictionaryStore'
export default {
  name: 'ZkDictionaryValue',
  props: ['type', 'value'],
  data () {
    return {
      result: ''
    }
  },
  mounted () {
    store.getNameByTypeAndValue(this.type, this.value).then(data => {
      this.result = data
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/dictionValue/src/main.vue